var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDragHandler24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7007 6.79903C13.7007 7.517 14.2827 8.09902 15.0006 8.09902C15.7186 8.09902 16.3006 7.517 16.3006 6.79903C16.3006 6.08106 15.7186 5.49902 15.0006 5.49902C14.2827 5.49902 13.7007 6.08106 13.7007 6.79903Z",
    fill: "#868E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7007 17.1994C13.7007 17.9174 14.2827 18.4994 15.0006 18.4994C15.7186 18.4994 16.3006 17.9174 16.3006 17.1994C16.3006 16.4814 15.7186 15.8994 15.0006 15.8994C14.2827 15.8994 13.7007 16.4814 13.7007 17.1994Z",
    fill: "#868E96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7007 11.9992C13.7007 12.7172 14.2827 13.2992 15.0006 13.2992C15.7186 13.2992 16.3006 12.7172 16.3006 11.9992C16.3006 11.2813 15.7186 10.6992 15.0006 10.6992C14.2827 10.6992 13.7007 11.2813 13.7007 11.9992Z",
    fill: "#868E96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70068 6.79903C7.70068 7.517 8.2827 8.09902 9.00067 8.09902C9.71864 8.09902 10.3006 7.517 10.3006 6.79903C10.3006 6.08106 9.71864 5.49902 9.00067 5.49902C8.2827 5.49902 7.70068 6.08106 7.70068 6.79903Z",
    fill: "#868E96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70068 17.1994C7.70068 17.9174 8.2827 18.4994 9.00067 18.4994C9.71864 18.4994 10.3006 17.9174 10.3006 17.1994C10.3006 16.4814 9.71864 15.8994 9.00067 15.8994C8.2827 15.8994 7.70068 16.4814 7.70068 17.1994Z",
    fill: "#868E96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70068 11.9992C7.70068 12.7172 8.2827 13.2992 9.00067 13.2992C9.71864 13.2992 10.3006 12.7172 10.3006 11.9992C10.3006 11.2813 9.71864 10.6992 9.00067 10.6992C8.2827 10.6992 7.70068 11.2813 7.70068 11.9992Z",
    fill: "#868E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragHandler24Line);
export default __webpack_public_path__ + "static/media/icon_drag_handler_24_line.85fe9445e5bd99a4d84820f935c86a72.svg";
export { ForwardRef as ReactComponent };